import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import { fetchAlumnoInscrito } from "./alumnoInscritoSlice";
import { fetchGrupo } from "./grupoSlice";


interface AlumnoAsignadoState {
    status: string;
    error: string;
    alumnoAsignadoList: any[],
    alumnoAsignado: {
        idGrupo: number | null;
        idUsuario: number | null;
        primerNombre: string | null;
        segundoNombre: string | null;
        primerApellido: string | null;
        segundoApellido: string | null;
        carnet: number | null;
        estado: number | null;
        estadoDescripcion: string | null;
        fileImage: string | null;
    }

}

const initialState: AlumnoAsignadoState = {
    status: 'idle',
    error: '',
    alumnoAsignadoList: [],
    alumnoAsignado: {
        idGrupo: null,
        idUsuario: null,
        primerNombre: null,
        segundoNombre: null,
        primerApellido: null,
        segundoApellido: null,
        carnet: null,
        estado: null,
        estadoDescripcion: null,
        fileImage: null
    }
}

export const fetchAlumnoAsignado = createAsyncThunk('fetchAlumnoAsignado', async ({ idGrupo, idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 112;
    const { result, message, data } = await getData({ idsp, idGrupo, idCiclo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyAlumnoAsignado = createAsyncThunk('modifyAlumnoAsignado', async ({ idGrupo, idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const alumnoAsignadoNew = selectAlumnoAsignado(state);
    const alumnoAsignadoAttributes = { ...alumnoAsignadoNew };
    const idsp = 113;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...alumnoAsignadoAttributes, idGrupo, idCiclo }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchAlumnoAsignado({ idGrupo, idCiclo }));
    dispatch(fetchAlumnoInscrito({ idCiclo }));
    dispatch(fetchGrupo({ idCiclo }));
    return rejectWithValue(message);
});

export const alumnoAsignadoSlice = createSlice({
    name: 'alumnoAsignado',
    initialState,
    reducers: {
        setAlumnoAsignadoList: (state, action) => {
            state.alumnoAsignadoList = action.payload;
        },
        setAlumnoAsignado: (state, action) => {
            state.alumnoAsignado = !action.payload ? initialState.alumnoAsignado : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAlumnoAsignado.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAlumnoAsignado.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.alumnoAsignadoList = data ? data : [];

            })
            .addCase(fetchAlumnoAsignado.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectAlumnoAsignadoList = (state: RootState) => state.alumnoAsignado.alumnoAsignadoList;
export const selectAlumnoAsignado = (state: RootState) => state.alumnoAsignado.alumnoAsignado;

export const { setAlumnoAsignadoList, setAlumnoAsignado } = alumnoAsignadoSlice.actions;

export default alumnoAsignadoSlice.reducer;